module.exports = __webpack_public_path__ + "static/media/unmuted.6764bc14.svg";